import { api } from '../plugins/axios_settings'

// Flex account (fleksitid) store module. Talks to the timerapi microservice via
// the same `api` instance the calendar uses for /hours. Namespaced to avoid
// colliding with the global action names in the common module.
const state = {
  flexBalance: { balance_minutes: 0, as_of: null, policy_name: null, max_positive_minutes: null, max_negative_minutes: null, settlement_period: null },
  flexTransactions: [],
  dailyFlexDeltas: [],
  avspaseringRequests: [],
  egenmeldingQuota: { own: null, child: null }
}

const getters = {
  getFlexBalance: state => state.flexBalance,
  getFlexBalanceMinutes: state => (state.flexBalance ? state.flexBalance.balance_minutes : 0),
  getFlexTransactions: state => state.flexTransactions,
  getDailyFlexDeltas: state => state.dailyFlexDeltas,
  getAvspaseringRequests: state => state.avspaseringRequests,
  getEgenmeldingQuota: state => state.egenmeldingQuota
}

const mutations = {
  SET_FLEX_BALANCE (state, balance) {
    state.flexBalance = balance
  },
  SET_FLEX_TRANSACTIONS (state, transactions) {
    state.flexTransactions = transactions
  },
  SET_DAILY_FLEX_DELTAS (state, deltas) {
    state.dailyFlexDeltas = deltas
  },
  SET_AVSPASERING_REQUESTS (state, requests) {
    state.avspaseringRequests = requests
  },
  SET_EGENMELDING_QUOTA (state, quota) {
    state.egenmeldingQuota = quota
  }
}

const actions = {
  GET_FLEX_BALANCE ({ commit }) {
    return new Promise((resolve, reject) => {
      api.get('/flex/balance')
        .then((response) => {
          commit('SET_FLEX_BALANCE', response.data.data)
          resolve(response.data.data)
        })
        .catch(reject)
    })
  },
  GET_FLEX_TRANSACTIONS ({ commit }, params = {}) {
    const query = new URLSearchParams()
    if (params.type) query.append('type', params.type)
    if (params.from) query.append('from', params.from)
    if (params.to) query.append('to', params.to)
    const qs = query.toString()
    return new Promise((resolve, reject) => {
      api.get(`/flex/transactions${qs ? `?${qs}` : ''}`)
        .then((response) => {
          commit('SET_FLEX_TRANSACTIONS', response.data.data)
          resolve(response.data.data)
        })
        .catch(reject)
    })
  },
  GET_DAILY_FLEX_DELTAS ({ commit }, params = {}) {
    const query = new URLSearchParams()
    if (params.from) query.append('from', params.from)
    if (params.to) query.append('to', params.to)
    const qs = query.toString()
    return new Promise((resolve, reject) => {
      api.get(`/flex/daily-deltas${qs ? `?${qs}` : ''}`)
        .then((response) => {
          commit('SET_DAILY_FLEX_DELTAS', response.data.data)
          resolve(response.data.data)
        })
        .catch(reject)
    })
  },
  GET_AVSPASERING_REQUESTS ({ commit }) {
    return new Promise((resolve, reject) => {
      api.get('/flex/avspasering')
        .then((response) => {
          commit('SET_AVSPASERING_REQUESTS', response.data.data)
          resolve(response.data.data)
        })
        .catch(reject)
    })
  },
  REQUEST_AVSPASERING (_, payload) {
    return api.post('/flex/avspasering', payload)
  },
  CANCEL_AVSPASERING (_, id) {
    return api.delete(`/flex/avspasering/${id}`)
  },
  GET_EGENMELDING_QUOTA ({ commit }) {
    return new Promise((resolve, reject) => {
      api.get('/egenmelding/quota')
        .then((response) => {
          commit('SET_EGENMELDING_QUOTA', response.data.data)
          resolve(response.data.data)
        })
        .catch(reject)
    })
  },
  // payload: { type: 'own'|'child', start_date: 'YYYY-MM-DD', days: int }
  REPORT_EGENMELDING (_, payload) {
    return api.post('/egenmelding', payload)
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
